import React from 'react';
import PropTypes from 'prop-types';
import { Route, IndexRoute } from 'react-router';
import { ReduxRouter } from 'redux-router';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import OpenBankingScreen from 'ggApp/shared/screens/OpenBanking/OpenBanking';
import AuthPackageWrap from 'ggApp/shared/components/AuthPackageWrap';

import {
    newCheckoutEnabledSelector as newCheckoutEnabled,
    yourTechMixFeatureFlag as yourTechMixFeatureFlagSelector,
    mixGlobalFlag as mixGlobalFlagSelector,
    termsAndConditionsFlag as termsAndConditionsFlagSelector,
} from 'ggApp/modules/featureFlag/selectors';
import { ModalComponent_Wrap as ModalWrap } from 'ggApp/modules/modal';
import DashboardLayoutWrap from 'ggApp/shared/components/DashboardLayoutWrap';

import ErrorPage from 'ggApp/shared/screens/ErrorPage';
import LandingPage from 'ggApp/shared/screens/PartnerProductPage';
import RootWrap from './routes/_wrap/dashboard';
import { PrefetchUser } from './routes/_wrap/prefetchUser';

import ModalRoutes from './routes/modal';
import createCartRoutes from './routes/cart';
import createCheckoutRoutes from './routes/checkout';
import createYourTechRoutes from './routes/your-tech';
import createYourPaymentsRoutes from './routes/your-payments';
import createYourProfileRoutes from './routes/your-profile';
import createYourFeedbackRoutes from './routes/your-feedback';
import createCompanyDashboardRoutes from './routes/company-dashboard';
import PaymentRoutes from './routes/payment';

// TODO Remove once new billing system can service change of payment method for subscription
import LegacyPaymentMethods from './routes/LegacyPaymentMethods';

import OrderStateStepWrap from './routes/_wrapOrderStateStep';
import { onRouteChange } from './utils/tracking';
import LandingPageWrap from './routes/landing/_wrap';

import PasswordRecovery from './shared/containers/passwordRecovery';

const enhance = connect(
    createStructuredSelector({
        newCheckoutFlag: newCheckoutEnabled,
        yourTechMixFeatureFlag: yourTechMixFeatureFlagSelector,
        mixGlobalFlag: mixGlobalFlagSelector,
        termsAndConditionsFlag: termsAndConditionsFlagSelector,
    }),
    (dispatch) => ({ dispatch }),
);

const Routes = ({
    newCheckoutFlag,
    yourTechMixFeatureFlag,
    mixGlobalFlag,
    termsAndConditionsFlag,
    dispatch,
}) => (
    <ReduxRouter>
        <Route path="/" component={PrefetchUser}>
            <Route path=":store" component={RootWrap}>
                <Route component={OrderStateStepWrap} onChange={onRouteChange(dispatch)}>
                    <Route component={ModalWrap} modalRoutes={ModalRoutes}>
                        {createCartRoutes({ newCheckoutFlag })}
                        {createCheckoutRoutes({ newCheckoutFlag })}
                        {PaymentRoutes}

                        {createYourFeedbackRoutes()}

                        <Route component={DashboardLayoutWrap}>
                            {createYourTechRoutes({
                                yourTechMixFeatureFlag,
                                mixGlobalFlag,
                                termsAndConditionsFlag,
                            })}
                            {createYourPaymentsRoutes()}
                            {createYourProfileRoutes()}
                            {createCompanyDashboardRoutes()}
                        </Route>

                        <Route path="open-banking" component={AuthPackageWrap}>
                            <IndexRoute component={OpenBankingScreen} />
                        </Route>
                        <Route component={LandingPageWrap}>
                            <Route path="landing" component={LandingPage} />
                        </Route>

                        <Route path="password-recovery" component={PasswordRecovery} />
                        <Route
                            path="payment-methods/:subscriptionId"
                            component={LegacyPaymentMethods}
                        />
                    </Route>
                </Route>

                <Route status={404} path="*" component={ErrorPage} />
            </Route>
        </Route>
    </ReduxRouter>
);

Routes.propTypes = {
    dispatch: PropTypes.func.isRequired,
    yourTechMixFeatureFlag: PropTypes.bool.isRequired,
    mixGlobalFlag: PropTypes.bool.isRequired,
    termsAndConditionsFlag: PropTypes.bool.isRequired,
};

export default enhance(Routes);
